import React from 'react';
import styles from '../../styles/FranchiseeModel.module.scss'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';

interface Props {
    franchiseeModelData: any;
}

const FranchiseeModel: React.FC<Props> = ({ franchiseeModelData }) => {
  const  footerModel = franchiseeModelData.footerModel;
    return (
        <div className={styles.franchiseeModel}>
            <Container>
                <Row>
                    <div className="text-center">
                        <h2>{franchiseeModelData?.sectionTitle}</h2>
                    </div>
                </Row>
                <Row>
                  <Col>
                    <Table>
                      <thead>
                        <tr className={styles.headtr}>
                          <th>Requirements</th>
                          <th colSpan={2}>Details</th>
                        </tr>
                      </thead>
                      <tbody className={styles.customtr}>
                        {franchiseeModelData?.franchiseeModel?.length > 0 &&
                          franchiseeModelData?.franchiseeModel.map((data: any) => {
                            return (
                             <>
                               <tr id={data.id}>
                                  <td>{data.particular}</td>
                                  <td>{data.values}</td>
                                </tr>
                             </>
                            )
                          })
                        }
                      </tbody>
                      <thead>
                         <tr className={styles.footertr}>
                            <th>{footerModel.particular || ''}</th>
                            <th colSpan={2}> {footerModel.values || ''} </th>
                          </tr>
                      </thead>
                    </Table>
                  </Col>
                </Row>
            </Container>
        </div>
    )
}
export default FranchiseeModel;